export type ErrorSelector = {
  sig: string
  inputs: any[]
  name: string
  type: string
  userdoc?: [
    {
      notice: string
      params?: Record<string, string>
    },
  ]
  devdoc?: [
    {
      details: string
      params?: Record<string, string>
    },
  ]
}

export type ErrorsType = {
  [LSP: string]: {
    [ERRORSIG: string]: ErrorSelector | undefined
  }
}

export enum ErrorType {
  EMPTY_REVERT = 'EMPTY_REVERT',
  INVALID = 'INVALID',
  PANIC = 'PANIC',
  ERROR = 'ERROR',
  CUSTOM_ERROR = 'CUSTOM_ERROR',
}

export type DetailedErrorArg = {
  name?: string // possible paramerter name of Error abi
  value?: string // parameter value of Error abi
  type?: string // parameter type of Error abi
  doc?: string // possible userdoc `@param` value
}

export type FullDetailedError = {
  hexSignature?: string // Error signature if it exists
  message: string // Description of the error if it exists
  userdoc?: string // Possible userdoc `@notice` value
  advanced?: {
    sig: string // Signature of Error abi
    name: string // Name of the Error abi function
    inputs: DetailedErrorArg[] // Arguments of Error abi
    devdoc: string // Possible devdoc of error `@dev`
  }
  data?: string // The Network data portion of the error (errordata)
  type: ErrorType // The type of the Error
  isEmpty?: boolean
  toJSON?: () => any // Allow serialization of an Error into iframe.
}

export type EmptyRevertPartialError = {
  hexSignature: string // Error signature if it exists
  message: string // The error message
  advanced: {
    sig: string // Signature of Error abi
    name: string // Name of the Error abi function
    inputs: DetailedErrorArg[] // Arguments of Error abi
    devdoc: string // Possible devdoc of error `@dev`
  }
  data: string // The Network data portion of the error (errordata)
  type: ErrorType.EMPTY_REVERT // The type of the Error
  isEmpty: true
  toJSON?: () => any // Allow serialization of an Error into iframe.
}

export type PanicPartialError = {
  hexSignature: string // Error signature if it exists
  message: string // The error message
  advanced: {
    sig: string // Signature of Error abi
    name: string // Name of the Error abi function
    inputs: DetailedErrorArg[] // Arguments of Error abi
    devdoc: string // Possible devdoc of error `@dev`
  }
  data: string // The Network data portion of the error (errordata)
  type: ErrorType.PANIC // The type of the Error
  toJSON?: () => any // Allow serialization of an Error into iframe.
}

export type CustomErrorPartialError = {
  hexSignature: string // Error signature if it exists
  message: string // The error message
  userdoc?: string // Possible userdoc `@notice` value
  advanced: {
    sig: string // Signature of Error abi
    name: string // Name of the Error abi function
    inputs: DetailedErrorArg[] // Arguments of Error abi
    devdoc?: string // Possible devdoc of error `@dev`
  }
  data: string // The Network data portion of the error (errordata)
  type: ErrorType.CUSTOM_ERROR // The type of the Error
  toJSON?: () => any // Allow serialization of an Error into iframe.
}

export type ErrorPartialError = {
  hexSignature: string // Error signature if it exists
  message: string // The error message
  advanced: {
    sig: string // Signature of Error abi
    name: string // Name of the Error abi function
    inputs: DetailedErrorArg[] // Arguments of Error abi
    devdoc: string // Possible devdoc of error `@dev`
  }
  data: string // The Network data portion of the error (errordata)
  type: ErrorType.ERROR // The type of the Error
  toJSON?: () => any // Allow serialization of an Error into iframe.
}

export type InvalidPartialError = {
  type: ErrorType.INVALID // The type of the Error
}

type DetailedPartError =
  | EmptyRevertPartialError
  | PanicPartialError
  | CustomErrorPartialError
  | ErrorPartialError
  | InvalidPartialError

export type ErrorMessage = {
  name?: string
  message: string
}

// This is an interface because "extents"
export type DetailedError = Error & DetailedPartError
